(function ( $ ) {

    (function () {

        $('.order-group-radio-item .order-radio').click(function(e) {
            let pathArray = window.location.pathname.split('/');
            const lang = pathArray[1];
            let default_option = (lang !=="ua") ? "Выберите город" : "Виберіть місто";
            let cityText = (lang !=="ua") ? "Город" : "Місто";
            let addressText = (lang !=="ua") ? "Адрес" : "Адреса";
            $('.delivery-options').html('');
            let itemNumber =  $(this).closest(".order-group-radio-item").data("deliveryId");
            let isConfirmed = $(this).closest(".order-group-radio-item").data("deliveryConfirmed");
            if (itemNumber !== 3 && isConfirmed ) { //not Укрпочта
                $(this).closest(".order-group-radio-item").find('.delivery-options').html(`
                <div class="position-relative wrapper" style="width: 350px;">
                    <input type="text" name="city" class="order-input delivery-cities-input" placeholder="${cityText}" required autocomplete="off">
                    <i class="fas fa-spinner fa-spin spinner spinner-city"></i>
                    <div class="error"></div>
                </div>
                <div class="cities-list">
                    <ul>
                    </ul>
                </div>
                <div class="position-relative wrapper" style="width: 350px;">
                    <select class="order-select" name="address" required>
                        <option disabled selected>${default_option}</option>
                    </select>
                    <i class="fas fa-spinner fa-spin spinner spinner-address"></i>
                    <div class="error"></div>
                </div>
            `);
            } else {
                $(this).closest(".order-group-radio-item").find('.delivery-options').html(`
                <input type="text" name="city" class="order-input" placeholder="${cityText}" required>
                <input type="text" name="address" class="order-input " placeholder="${addressText}" required>
            `);
            }
        });

        $(document).on("keyup", "[data-delivery-id='1'] .delivery-cities-input", function () {
            let searchQuery = $(this).val();
            let token = $('meta[name="csrf-token"]').attr('content');
            let pathArray = window.location.pathname.split('/');
            const lang = pathArray[1];
            let errorMessage = (lang !=="ua") ? "Ошибка Новой почты" : "Помилка Нової пошти";
            $(this).closest('.wrapper').find('.error').html('');
            if (searchQuery.length >= 3) {
                $("#checkout-form .spinner-city").show();
                axios
                    .post(`/ajax/novaposhta/cities`, {
                        search_query: searchQuery,
                    }, {
                        headers: {
                            'X-CSRF-TOKEN': token
                        }
                    })
                    .then(resp => {
                        // console.log(resp.data);
                        $('.delivery-options .order-select').html('');
                        $('.delivery-options .cities-list ul').html('');
                        if ( resp.data.cities.length) {
                            $('.delivery-options .cities-list').css("display", "flex");
                        } else {
                            $('.delivery-options .cities-list').css("display", "none");
                        }
                        resp.data.cities.forEach((city) => {
                            let cityName = (lang !== "ua") ? city.DescriptionRu : city.Description;
                            $('.delivery-options .cities-list ul').append(`<li data-city-ref="${city.Ref}" data-city-name="${cityName}">${cityName}</li>`);
                        })
                    })
                    .catch(error => {
                        $(this).closest('.wrapper').find('.error').html(errorMessage);
                    })
                    .then(() => {
                        $("#checkout-form .spinner-city").hide();
                    });
            }
        });

        $(document).on("keyup", "[data-delivery-id='2'] .delivery-cities-input", function () {
            let searchQuery = $(this).val();
            let token = $('meta[name="csrf-token"]').attr('content');
            let pathArray = window.location.pathname.split('/');
            const lang = pathArray[1];
            let errorMessage = (lang !=="ua") ? "Ошибка Justin" : "Помилка Justin";
            $(this).closest('.wrapper').find('.error').html('');
            if (searchQuery.length >= 3) {
                $("#checkout-form .spinner-city").show();
                axios
                    .post(`/ajax/justin/cities`, {
                        search_query: searchQuery,
                        lang: (lang !== "ua") ? "ru" : "ua"
                    }, {
                        headers: {
                            'X-CSRF-TOKEN': token
                        }
                    })
                    .then(resp => {
                        $('.delivery-options .order-select').html('');
                        $('.delivery-options .cities-list ul').html('');
                        if ( resp.data.cities.length) {
                            $('.delivery-options .cities-list').css("display", "flex");
                        } else {
                            $('.delivery-options .cities-list').css("display", "none");
                        }
                        resp.data.cities.forEach((city) => {
                            let cityName = city.fields.descr;
                            let uuid = city.fields.uuid;
                            $('.delivery-options .cities-list ul').append(`<li data-city-uuid="${uuid}" data-city-name="${cityName}">${cityName}</li>`);
                        })
                    })
                    .catch(error => {
                        $(this).closest('.wrapper').find('.error').html(errorMessage);
                    })
                    .then(() => {
                        $("#checkout-form .spinner-city").hide();
                    });
            }
        });

        $(window).click(function() {
            if ($(".delivery-options .cities-list").is(":visible")) {
                $('.delivery-options .cities-list').hide();
            }
        });

        $(document).on("click", "[data-delivery-id='1'] .delivery-options .cities-list ul li", function () {
            let cityRef = $(this).data('cityRef');
            let cityName = $(this).data('cityName');
            $('.delivery-options .cities-list').css("display", "none");

            $("[data-delivery-id='1'].delivery-cities-input").data('cityRef', cityRef);
            $("[data-delivery-id='1'] .delivery-cities-input").val(cityName);


            let token = $('meta[name="csrf-token"]').attr('content');
            let pathArray = window.location.pathname.split('/');
            const lang = pathArray[1];

            let errorMessage = (lang !=="ua") ? "Ошибка Новой почты" : "Помилка Нової пошти";
            $('.delivery-options .order-select').closest('.wrapper').find('.error').html('');

            let default_option = (lang !=="ua") ? "Выберите город" : "Виберіть місто";

            $("#checkout-form .spinner-address").show();

            axios
                .post(`/ajax/novaposhta/warehouses`, {
                    cityRef: cityRef,
                    language: (lang !== "ua") ? "ru" : null,
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(resp => {
                    // console.log(resp.data);
                    $('.delivery-options .order-select').html(``);
                    // $('.delivery-options .order-select').html(`<option disabled selected>${default_option}</option>`);
                    resp.data.warehouses.forEach((warehouse) => {
                        let address = (lang !== "ua") ? warehouse.DescriptionRu : warehouse.Description;
                        $('.delivery-options .order-select').append(`<option value="${address}">${address}</option>`);
                    })
                })
                .catch(error => {
                    $('.delivery-options .order-select').closest('.wrapper').find('.error').html(errorMessage);
                })
                .then(() => {
                    $("#checkout-form .spinner-address").hide();
                });
        });

        $(document).on("click", "[data-delivery-id='2'] .delivery-options .cities-list ul li", function () {
            let cityUuid = $(this).data('cityUuid');
            let cityName = $(this).data('cityName');
            $('.delivery-options .cities-list').css("display", "none");

            $("[data-delivery-id='2'].delivery-cities-input").data('cityRef', cityUuid);
            $("[data-delivery-id='2'] .delivery-cities-input").val(cityName);

            let token = $('meta[name="csrf-token"]').attr('content');
            let pathArray = window.location.pathname.split('/');
            const lang = pathArray[1];

            let errorMessage = (lang !=="ua") ? "Ошибка Justin" : "Помилка Justin";
            $('.delivery-options .order-select').closest('.wrapper').find('.error').html('');

            let default_option = (lang !=="ua") ? "Выберите город" : "Виберіть місто";

            $("#checkout-form .spinner-address").show();

            axios
                .post(`/ajax/justin/warehouses`, {
                    uuid: cityUuid,
                    language: (lang !== "ua") ? "ru" : "ua",
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(resp => {
                    // console.log(resp.data);
                    $('.delivery-options .order-select').html(``);
                    // $('.delivery-options .order-select').html(`<option disabled selected>${default_option}</option>`);
                    resp.data.warehouses.forEach((warehouse) => {
                        let address = warehouse.fields.address;
                        let descr = warehouse.fields.descr;
                        $('.delivery-options .order-select').append(`<option value="${descr}, ${address}">${descr}, ${address}</option>`);
                    })
                })
                .catch(error => {
                    $('.delivery-options .order-select').closest('.wrapper').find('.error').html(errorMessage);
                })
                .then(() => {
                    $("#checkout-form .spinner-address").hide();
                });
        });
    }());

}( jQuery ));
